<div class="datiq-cell-action">
    <ng-container *ngIf="!!!settings.tooltip && !!!settings.disabled">
        <ng-container [ngSwitch]="settings.type">
            <ng-container *ngSwitchCase="'icon'">
                <button
                    mat-icon-button
                    [disabled]="settings.disabled"
                    (click)="$event.stopPropagation(); clicked(settings.action)"
                    [ngClass]="{ 'datiq-cell-action__disabled': settings.disabled }"
                    [attr.data-testid]="settings.id"
                >
                    <mat-icon [svgIcon]="settings.icon"></mat-icon>
                </button>
            </ng-container>
            <ng-container *ngSwitchCase="'button'">
                <datiq-button
                    [settings]="settings.button"
                    (clicked)="clicked(settings.action)"
                    [attr.data-testid]="settings.id"
                ></datiq-button>
            </ng-container>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="!settings.disabled && !!settings.tooltip">
        <datiq-tooltip
            [settings]="settings.tooltip"
        >
            <div datiq-tooltip-label>
                <ng-container [ngSwitch]="settings.type">
                    <ng-container *ngSwitchCase="'icon'">
                        <button
                            mat-icon-button
                            [disabled]="settings.disabled"
                            (click)="clicked(settings.action)"
                            [ngClass]="{ 'datiq-cell-action__disabled': settings.disabled }"
                            [attr.data-testid]="settings.id"
                        >
                            <mat-icon [svgIcon]="settings.icon"></mat-icon>
                        </button>
                    </ng-container>
                    <ng-container *ngSwitchCase="'button'">
                        <datiq-button
                            [settings]="settings.button"
                            (clicked)="clicked(settings.action)"
                            [attr.data-testid]="settings.id"
                        ></datiq-button>
                    </ng-container>
                </ng-container>
            </div>
        </datiq-tooltip>
    </ng-container>
    <ng-container *ngIf="settings.disabled && !!settings.disabledTooltip">
        <datiq-tooltip
            [settings]="settings.disabledTooltip"
        >
            <div datiq-tooltip-label>
                <ng-container [ngSwitch]="settings.type">
                    <ng-container *ngSwitchCase="'icon'">
                        <button
                            mat-icon-button
                            [disabled]="settings.disabled"
                            (click)="clicked(settings.action)"
                            [ngClass]="{ 'datiq-cell-action__disabled': settings.disabled }"
                            [attr.data-testid]="settings.id"
                        >
                            <mat-icon [svgIcon]="settings.icon"></mat-icon>
                        </button>
                    </ng-container>
                    <ng-container *ngSwitchCase="'button'">
                        <datiq-button
                            [settings]="settings.button"
                            (clicked)="clicked(settings.action)"
                            [attr.data-testid]="settings.id"
                        ></datiq-button>
                    </ng-container>
                </ng-container>
            </div>
        </datiq-tooltip>
    </ng-container>
</div>
